import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  role: string;
  location: string;
  content: string;
  imageInitials: string;
}
export function TestimonialCard({
  name,
  role,
  location,
  content,
  imageInitials
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 flex flex-col h-full" data-id="element-276">
      <div className="flex items-center mb-4" data-id="element-277">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-278" />)}
      </div>
      <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-279">"{content}"</p>
      <div className="flex items-center mt-auto" data-id="element-280">
        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold mr-3 flex-shrink-0" data-id="element-281">
          {imageInitials}
        </div>
        <div data-id="element-282">
          <p className="font-bold text-gray-900 text-sm" data-id="element-283">{name}</p>
          <p className="text-xs text-gray-500" data-id="element-284">{role}</p>
          <p className="text-xs text-gray-400" data-id="element-285">{location}</p>
        </div>
      </div>
    </div>;
}